import { createStore } from 'vuex'
import {headerfooter} from "vue3-header-footer"
import {livechat} from "vue3-live-chat"
export default createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    headerfooter,
    livechat

  }
})
